import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { toast } from 'sonner';
import { API, axios } from '../../utils/api';
import { messaggioErrore } from '../../utils/agenda';

// Eliminare un immobile o un cliente (solo admin), nello stile dell'app: "Eliminare {nome}? Verranno rimossi N immobili,
// N visite, N documenti. Non si può annullare." Per il cliente si scrive ELIMINA. Il server lo tiene 30 giorni nel
// cestino (Impostazioni → Cestino), poi lo cancella davvero con i file (backend/cestino.py).

const conta = (n, una, tante) => `${n} ${n === 1 ? una : tante}`;

export const frasiEliminazione = (tipo, a) => {
  if (tipo === 'cliente') {
    // i prospetti del mutuo si nominano solo quando ce ne sono: sono dati economici della famiglia e vanno via
    // con lui, ma una riga in più che dice sempre "0 prospetti" renderebbe la frase più lunga e meno letta
    const mutui = a.prospetti_mutuo ? ` e ${conta(a.prospetti_mutuo, 'prospetto mutuo', 'prospetti mutuo')}` : '';
    return `Verranno rimossi ${conta(a.immobili, 'immobile', 'immobili')}, ${conta(a.visite, 'visita', 'visite')}, ${conta(a.documenti, 'documento', 'documenti')}${mutui}.`;
  }
  return `Verranno rimosse ${conta(a.visite, 'visita', 'visite')} e ${conta(a.proposte, 'proposta', 'proposte')}.`;
};

const Eliminazione = ({ tipo, id, onChiudi, onEliminato }) => {
  const [anteprima, setAnteprima] = useState(null);
  const [parola, setParola] = useState('');
  const [attesa, setAttesa] = useState(false);
  const annulla = useRef(null);
  const percorso = tipo === 'cliente' ? `${API}/clienti/${id}` : `${API}/immobili/${id}`;

  useEffect(() => {
    axios.get(`${percorso}/eliminazione`).then((r) => setAnteprima(r.data)).catch(() => { toast.error('Non riesco a preparare l\'eliminazione'); onChiudi(); });
  }, [percorso, onChiudi]);
  useEffect(() => {
    const esc = (e) => { if (e.key === 'Escape') onChiudi(); };
    document.addEventListener('keydown', esc);
    return () => document.removeEventListener('keydown', esc);
  }, [onChiudi]);
  useEffect(() => { if (anteprima) annulla.current?.focus(); }, [anteprima]);

  const serveParola = tipo === 'cliente';
  const pronta = anteprima && (!serveParola || parola.trim() === (anteprima.parola || 'ELIMINA'));
  const elimina = async () => {
    if (!pronta || attesa) return;
    setAttesa(true);
    try {
      await axios.delete(percorso, serveParola ? { params: { conferma: parola.trim() } } : undefined);
      toast.success(`${anteprima.nome}: nel cestino per ${anteprima.giorni} giorni`);
      onEliminato();
    } catch (e) {
      toast.error(messaggioErrore(e, 'Non eliminato. Riprovate.'));
      setAttesa(false);
    }
  };

  const radice = document.querySelector('.mk-staff') || document.body;
  return createPortal(
    <div className="st st-modale elimina-modale" role="presentation" onMouseDown={(e) => { if (e.target === e.currentTarget) onChiudi(); }}>
      <div className="scatola" role="alertdialog" aria-modal="true" aria-labelledby="elimina-titolo" aria-describedby="elimina-testo" data-testid="finestra-elimina">
        {!anteprima ? <p className="niente">Preparo…</p> : (
          <>
            <h3 id="elimina-titolo">Eliminare {anteprima.nome}?</h3>
            <p id="elimina-testo">{frasiEliminazione(tipo, anteprima)} Non si può annullare.</p>
            <p className="nota">Per {anteprima.giorni} giorni resta in Impostazioni → Cestino, da dove si può recuperare; poi è cancellato per sempre, file compresi.</p>
            {serveParola && (
              <label className="parola">Per confermare scrivete <b>{anteprima.parola}</b>
                <input value={parola} onChange={(e) => setParola(e.target.value)} autoComplete="off" spellCheck={false} aria-label={`Scrivete ${anteprima.parola} per confermare`}
                  onKeyDown={(e) => { if (e.key === 'Enter') elimina(); }} />
              </label>
            )}
            <div className="bottoni">
              <button type="button" className="btn sm" ref={annulla} onClick={onChiudi}>Annulla</button>
              <button type="button" className="btn sm rosso" onClick={elimina} disabled={!pronta || attesa}>{attesa ? 'Elimino…' : 'Elimina'}</button>
            </div>
          </>
        )}
      </div>
    </div>,
    radice,
  );
};

export default Eliminazione;
